import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { compose } from 'recompose'
import { FormData, Button } from 'components/misc'
import { ModalCTA } from 'containers/misc'
import { form } from 'helpers/decorators'
import { apiConfiguration, apiAssessors } from 'helpers/decorators/api'
import { Title } from 'components/layout'
import { FormattedDate } from 'components/intl'
import { Select, Input, InputPhone, Checkbox, Textarea } from 'components/fields'
import TaskRequestAdditionalInfo from '../TaskRequestAdditionalInfo/TaskRequestAdditionalInfo'
import TaskReturn from '../TaskReturn/TaskReturn'
import { connect } from 'react-redux'
import validateAssessor, { asyncValidate } from '../../../../models/tasks/validateAssessor'
import { checkEmail } from 'redux/modules/api/asyncValidations'
import styles from './task-assessor-edit.styl'
import { activitySectionDropdownSelector, mapActivitiesCategories, mapActivitiesParents } from '../../../../redux/selectors/activities'
import { ACTIVITY_CATEGORIES } from '../../../../constants/enums'
import { FormattedMessage, injectIntl } from 'react-intl'

function getDefaultValues(registration) {
  const activityCategory = get(registration, 'activity.activityCategory') ?? get(registration, 'activityCategory')
  const rawActivitySection = get(registration, 'activity.activitySection') ?? get(registration, 'activityCategory.activitySection')
  const activitySection = rawActivitySection && { value: get(rawActivitySection, 'value'), label: get(rawActivitySection, 'translationText') }

  return {
    ...registration,
    ...(get(registration, 'assessor.person') ?? {}),
    ...(get(registration, 'activity') ?? {}),
    activityCategory,
    activitySection,
    assessor: get(registration, 'assessor'),
    phoneNumber: get(registration, 'assessor.person.phone'),
    'phoneType.value': get(registration, 'assessor.person.phoneType.value'),
    company: get(registration, 'company'),
    companyNumber: get(registration, 'companyNumber'),
    line1: get(registration, 'line1') || get(registration, 'assessor.person.address.line1') || '---',
    line2: get(registration, 'line2') ||  get(registration, 'assessor.person.address.line2') || '---',
    stateOrProvinceOrRegion: get(registration, 'stateOrProvinceOrRegion') || get(registration, 'assessor.person.address.stateOrProvinceOrRegion') || '---',
    city: get(registration, 'city') || get(registration, 'assessor.person.address.city') || '---',
    zipCode: get(registration, 'zipCode') ||  get(registration, 'assessor.person.address.zipCode') || '---',
    countryId: get(registration, 'assessor.person.address.country.id'),
    note: get(registration, 'note') ||  get(registration, 'assessor.person.assessorDetail.note')
  }
}

const enhance = compose(
  connect(() => {}, {
    checkEmail,
  }),
  apiConfiguration(),
  apiAssessors(),
  form({
    form: 'taskParticipantEdit',
    initialProps: 'registration',
    initialPropsMapper: getDefaultValues,
    validate: validateAssessor,
    asyncValidate,
  }),
  injectIntl,
  connect(({ api, auth }) => ({
    blobAccessAuthorizationCode: get(auth, 'user.blobAccessAuthorizationCode'),
    dropdownSections: activitySectionDropdownSelector(api),
  }))
)

class TaskAssessorEdit extends Component {
  static propTypes = {
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    forWWCUpdate: PropTypes.bool,
    forActivityRegistration: PropTypes.bool,
    onEditSubmit: PropTypes.func,
    onDeleteSubmit: PropTypes.func,
    isAssessorManagementEnabled: PropTypes.bool,
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    registration: PropTypes.object.isRequired,
    registrationFiles: PropTypes.list,
    values: PropTypes.object.isRequired,
    change: PropTypes.func.isRequired,
    getAssessorWWCFile: PropTypes.func.isRequired,
    checkAssessorEmailAvailability: PropTypes.func,
    assessors: PropTypes.any,
    blobAccessAuthorizationCode: PropTypes.string,
    dropdownSections: PropTypes.list,
    activities: PropTypes.object,
    intl: PropTypes.object.isRequired,
  }

  state = {
    additionalInfoDialogOpen: false,
    deleteDialogOpen: false,
    isAlreadyRegistered: true
  }

  static defaultProps = {
    forActivityRegistration: false
  }


  componentDidMount() {
    const { registration } = this.props
    const defaultValues = getDefaultValues(registration)
    const organizationId = get(defaultValues, 'organizationId') ?? get(defaultValues, 'organization.id')
    const activityCategoryId = get(defaultValues, 'assessorActivityCategoryRegistration.id') ?? get(defaultValues, 'activityCategory.id')

    if (this.isForAssessorRegistration()) {
      this.props.getAssessorWWCFile(get(registration, 'id'))
      this.props.checkAssessorEmailAvailability(get(defaultValues, 'email'), organizationId, activityCategoryId).then(r => {
        this.setState({ isAlreadyRegistered: !r.body.available })
      })
    }
  }

  isForAssessorRegistration() {
    const { forWWCUpdate, forActivityRegistration } = this.props

    return !forWWCUpdate && !forActivityRegistration
  }

  openAdditionalInfoDialog = () => this.setState({ additionalInfoDialogOpen: true })
  closeAdditionalInfoDialog = () => this.setState({ additionalInfoDialogOpen: false })

  openDeleteDialog = () => this.setState({ deleteDialogOpen: true })
  closeDeleteDialog = () => this.setState({ deleteDialogOpen: false })
  handleSubmitDeleteDialog = (formId, fields) => {
    this.props.onDeleteSubmit(get(this.props.registration, 'id'), fields)
  }

  handleSubmit = data => {
    return this.props.onEditSubmit(get(this.props.registration, 'id'), data)
  }

  handleChangeSection = newValue => {
    this.props.change('activitySection', newValue)
    this.props.change('activityCategory', null)
  }
  handleChangeCategory = newValue => {
    this.props.change('activityCategory', { parent: { id: get(newValue, 'value'), label: get(newValue, 'label') } })
  }
  render() {
    /* eslint complexity: "off" */
    const {
      submitting,
      forWWCUpdate,
      forActivityRegistration,
      registration,
      handleSubmit,
      isAssessorManagementEnabled,
      codeLists,
      common,
      values,
      assessors,
      blobAccessAuthorizationCode,
      dropdownSections,
      activities,
      registrationFiles,
      intl,
    } = this.props
    const {
      additionalInfoDialogOpen,
      deleteDialogOpen,
      isAlreadyRegistered,
    } = this.state

    const isApplyCPNNeeded = get(registration, 'isApplyCPNNeeded')
    const wwcFile = get(registration, 'assessorFile') ?? get(registration, 'assessor.assessorWWC') ?? get(assessors, 'wwcFile.data')
    const wwcFileName = get(wwcFile, 'logicalFilename')
    const wwcFileUrl = get(wwcFile, 'fileUrl') ? `${get(wwcFile, 'fileUrl')}&authorizationCode=${blobAccessAuthorizationCode}` : undefined
    const wwcExpires = get(wwcFile, 'childProtectionExpirationDate') ?? get(registration, 'childProtectionExpirationDate')
    const wwcCpn = get(wwcFile, 'childProtectionNumber') ?? get(registration, 'childProtectionNumber')
    const wwcExemptionReason = get(wwcFile, 'assessorWWCExemptionReason') ?? get(registration, 'assessorWWCExemptionReason')
    const forAssessorRegistration = this.isForAssessorRegistration()
    const withInvitedBy = forAssessorRegistration
    const withAwardUnit = forAssessorRegistration || forWWCUpdate
    const canEditAssessor = forAssessorRegistration && !isAlreadyRegistered
    const withActivity = forActivityRegistration
    const canEditActivityRegistration = forActivityRegistration
    const noDelete = forWWCUpdate
    const noSave = forWWCUpdate || forActivityRegistration
    const canSave = canEditAssessor || canEditActivityRegistration
    // activity registration
    const canEditActivityCategory = false
    const sectionValue = get(values, 'activitySection.value')
    const categoryId = get(values, 'activityCategory.parent.id')
    const subcategoryId = get(values, 'activityCategory.id')
    const isOthersSubCategory = ACTIVITY_CATEGORIES.other.id === subcategoryId
    const missingSection = !sectionValue
    const missingCategory = !sectionValue || !get(values, 'activityCategory.parent.id')
    const mappedCategories = mapActivitiesParents(activities?.parents ?? [], sectionValue)
    const mappedSubCategories = mapActivitiesCategories(
        activities?.list ?? [],
        categoryId,
        intl.formatMessage({
            id: 'label.other',
            defaultMessage: 'Other'
        })
    )

    const EMPTY = 'N/A'

    const defaultValues = getDefaultValues(registration)

    const name = [get(defaultValues, 'firstName'), get(defaultValues, 'middleName'), get(defaultValues, 'lastName')].filter(v => v).join(' ')

    const email = get(defaultValues, 'email')

    const modalCTAOpen = additionalInfoDialogOpen || deleteDialogOpen

    return (
      <div className={`${styles.wrapper} task-assessor-edit`}>
        {!modalCTAOpen && <form key={isAlreadyRegistered} onSubmit={handleSubmit(this.handleSubmit)}>
          <Title h2>{`${name} (${email})`}</Title>
          <div className={`${styles.assessorRegistration} ${forAssessorRegistration ? styles.forApproval : ''}`}>
            <div className="row">
              {withInvitedBy && <div className="col-xs-6">
                <FormData label="Invited by" intlKey="label.invited_by">
                  {`${get(registration, 'invitedBy.name')} (${get(registration, 'invitedBy.email')})`}
                </FormData>
              </div>}
              {withAwardUnit && <div className="col-xs-6">
                <FormData label="Award unit" intlKey="label.award_unit">
                  {get(registration, 'assessor.organization.name')}
                </FormData>
              </div>}
            </div>
            <Title h3 intlKey="moduleTitle.assessor_details">
              Assessor details
            </Title>
            {isAlreadyRegistered && forAssessorRegistration && <Title h4 intlKey="label.already_registered_as_assessor">
              This person is already registered as assessor in other award unit, hence you cannot edit their details.
            </Title>}
            {!forActivityRegistration && <div>
            <div className="row">
              <div className="col-xs-2">
                <Select
                  label="Title"
                  intlKey="label.title"
                  name="title"
                  options={codeLists.titles.list}
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="First name"
                  intlKey="label.first_name"
                  name='firstName'
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="Middle name"
                  intlKey="label.middle_name"
                  name="middleName"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="Last name"
                  intlKey="label.last_name"
                  name="lastName"
                  disabled={!canEditAssessor}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-4">
                <Input
                  label="Email"
                  intlKey="label.email"
                  name="email"
                  disabled={true}
                />
              </div>
              <div className="col-xs-4">
                <Input
                  label="Secondary email"
                  intlKey="label.secondary_email"
                  name="secondaryEmail"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-4">
                <Input
                  label="Tertiary email"
                  intlKey="label.tertiary_email"
                  name="tertiaryEmail"
                  disabled={!canEditAssessor}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-3">
                <InputPhone
                  label="Phone number"
                  intlKey="label.phone_number"
                  name="phoneNumber"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Select
                  label="Phone type"
                  intlKey="label.phone_type"
                  name="phoneType.value"
                  options={codeLists.phoneTypes.list}
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="Company name"
                  intlKey="label.company_name"
                  name="company"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <InputPhone
                  label="Company number"
                  intlKey="label.company_number"
                  name="companyNumber"
                  disabled={!canEditAssessor}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <Input
                  label="Address Line 1"
                  intlKey="label.addressLine1"
                  name="line1"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-6">
                <Input
                  label="Address Line 2"
                  intlKey="label.addressLine2"
                  name="line2"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="State/Province/Region"
                  intlKey="label.state_province"
                  name="stateOrProvinceOrRegion"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="City"
                  intlKey="label.city"
                  name="city"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Input
                  label="Post code"
                  intlKey="label.post_code"
                  name="zipCode"
                  disabled={!canEditAssessor}
                />
              </div>
              <div className="col-xs-3">
                <Select
                  label="Country"
                  intlKey="label.country"
                  name="countryId"
                  options={common.countries.list}
                  searchable
                  disabled={!canEditAssessor}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <Textarea
                    label="Note visible only to Award Staff"
                    intlKey="label.assessor_edit_note"
                    name="note"
                    disabled={!canEditAssessor}
                />
              </div>

            </div>
            <div className={`${forWWCUpdate ? styles.forApproval : ''}`}>
              <div className="row">
                <div className="col-xs-3">
                  <FormData
                    label="Child protection number"
                    intlKey="label.child_protection_number"
                  >
                    {isApplyCPNNeeded ? <FormattedMessage
                      id="label.i_need_apply_cpn"
                      defaultMessage="I need to apply for my CPN (Assessor will need to provide WWC before they can start working with participants)"
                    /> : wwcExemptionReason ? EMPTY : wwcCpn}
                  </FormData>
                </div>
                <div className="col-xs-3">
                  <FormData
                    label="WWC Expired"
                    intlKey="label.wwc_expired"
                  >
                    {wwcExemptionReason ? EMPTY : (wwcExpires === null ? EMPTY : <FormattedDate value={wwcExpires} />)}
                  </FormData>
                </div>
                <div className="col-xs-3">
                  {!wwcExemptionReason &&
                    <a href={wwcFileUrl} target="_blank" rel="noreferrer">
                      <Button
                        className={styles.button}
                        type="button"
                        secondary
                      >
                        {wwcFileName}
                      </Button>
                    </a>}
                </div>
                <div className="col-xs-3">
                  <FormData label="Exemption reason" intlKey="label.wwc_exemption">
                    {wwcExemptionReason
                      ? wwcExemptionReason
                      : EMPTY}
                  </FormData>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-4">
                <Checkbox
                  name="previousWorkAsAssessor"
                  label="Previously worked as Assessor"
                  intlKey="label.previously_worked_as_assessor"
                  justify
                  disabled={!canEditAssessor}
                />
              </div>
              {Boolean(get(values, 'previousWorkAsAssessor')) && (
                <div className="col-xs-4">
                  <Input
                    type="number"
                    min="0"
                    label="How many years?"
                    intlKey="label.how_many_years"
                    name="workExperienceLength"
                    disabled={!canEditAssessor}
                  />
                </div>
              )}
            </div>
            </div>}
          </div>


          {withActivity && <div className={`${styles.activityRegistration} ${forActivityRegistration ? styles.forApproval : ''}`}>
            <Title h3 intlKey="moduleTitle.assessed_activities">
              Assessed Activities
            </Title>
            <div className="row">
              <div className="col-xs-4">
                <Select
                    label="Activity Section"
                    intlKey="label.section"
                    name="activitySection"
                    options={dropdownSections}
                    disabled={!canEditActivityRegistration || !canEditActivityCategory}
                    onChange={this.handleChangeSection}
                />
              </div>
              <div className="col-xs-4">
                <Select
                    label="Activity Type"
                    intlKey="label.activity_type"
                    name="activityCategory.parent.id"
                    options={mappedCategories}
                    searchable
                    sorted
                    disabled={!canEditActivityRegistration || missingSection || !canEditActivityCategory}
                    onChange={this.handleChangeCategory}
                />
              </div>
              <div className="col-xs-4">
                <Select
                    label="Activity"
                    intlKey="label.activity"
                    name="activityCategory.id"
                    options={mappedSubCategories}
                    sorted
                    disabled={!canEditActivityRegistration || missingCategory || !canEditActivityCategory}
                />
              </div>
              {isOthersSubCategory && <div className="col-xs-4">
                <Input
                    label="Other activity"
                    intlKey="label.other_activity"
                    name="activityCategory.name"
                    maxLength={512}
                    disabled={!canEditActivityRegistration}
                />
              </div>}
            </div>
            <Title h3 intlKey="moduleTitle.qualifications_held">
              Qualifications held
            </Title>
            <div className={styles.flexRow}>
              <Checkbox
                name="universityDegree"
                label="University Degree"
                intlKey="label.university_degree"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="tafeQualification"
                label="TAFE Qualification"
                intlKey="label.tafe_qualification"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="apprenticeship"
                label="Apprenticeship"
                intlKey="label.apprenticeship"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="experience"
                label="Experience"
                intlKey="label.experience"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="membership"
                label="Membership"
                intlKey="label.membership"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="nonAccreditedTraining"
                label="Non-accredited Training"
                intlKey="label.non_accredited_training"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="organisational"
                label="Organisational"
                intlKey="label.organisational"
                disabled={!canEditActivityCategory}
              />
              <Checkbox
                name="peakBody"
                label="Peak Body"
                intlKey="label.peak_body"
                disabled={!canEditActivityCategory}
              />
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-12">
                <Textarea
                  name="relevantExperience"
                  label="Relevant Experience"
                  intlKey="label.relevant_experience"
                  disabled={!canEditActivityCategory}
                />
              </div>
            </div>
            <div className={styles.flexRow}>
              <Checkbox
                name="isPublicAvailable"
                label="Happy to assess other people"
                intlKey="label.assess_others"
                disabled={!canEditActivityCategory}
              />
            </div>
            <Title h3 intlKey="moduleTitle.files">
              Files
            </Title>
            <div className="row">

              {registrationFiles.map(item => {
                return (<div className="col-xs-3">
                  <a href={`${get(item, 'fileUrl')}&authorizationCode=${blobAccessAuthorizationCode}`} target="_blank" rel="noreferrer">
                    <Button
                        className={styles.button}
                        type="button"
                        secondary
                    >
                      {get(item, 'logicalFilename')}
                    </Button>
                  </a>
                </div>)
              })}
            </div>
            <br />
          </div>}

          <div className="row">
            <div className="col-xs-4">
              <Button
                type="button"
                secondary
                onClick={() => this.props.modal(null)}
                intlKey="button.close"
              >
                Close
              </Button>
              {!noDelete &&
                <Button
                  style={{ marginLeft: 10 }}
                  type="button"
                  negative
                  onClick={this.openDeleteDialog}
                  intlKey="button.delete"
                >
                  Delete
                </Button>}
            </div>
            <div className={!noSave ? 'col-xs-4' : 'col-xs-8 text--right'}>
              <Button
                type="button"
                secondary
                onClick={this.openAdditionalInfoDialog}
                intlKey="button.request_additional_info"
              >
                Request additional info
              </Button>
            </div>
            {!noSave &&
              <div className="col-xs-4 text--right">
                <Button
                  intlKey="button.save"
                  isLoading={submitting}
                  disabled={!canSave}
                >
                  Save
                </Button>
              </div>}
          </div>
        </form>}
        {additionalInfoDialogOpen && <ModalCTA relative>
          <TaskRequestAdditionalInfo
            id={`request-info-${get(registration, 'id')}`}
            onClose={this.closeAdditionalInfoDialog}
            person={defaultValues}
          />
        </ModalCTA>}
        {deleteDialogOpen && <ModalCTA relative>
          <TaskReturn
            returnTask={this.handleSubmitDeleteDialog}
            id={`registration-delete-${get(registration, 'id')}`}
            handleDismiss={this.closeDeleteDialog}
            title="Would you like to delete this registration?"
            intlKey="tasks.delete_registration"
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
            noNote
            negative
            ctaIntlKey="button.delete"
            deletionReasons
          />
        </ModalCTA>}
      </div>
    )
  }
}

export default enhance(TaskAssessorEdit)
